import { render, staticRenderFns } from "./SelectTags.vue?vue&type=template&id=0e6afc2e"
import script from "./SelectTags.vue?vue&type=script&lang=js"
export * from "./SelectTags.vue?vue&type=script&lang=js"
import style0 from "./SelectTags.vue?vue&type=style&index=0&id=0e6afc2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports